exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width {\r\n  top: 2.8rem;\r\n}\r\n\r\n.list-group-item-text {\r\n  font-size: small;\r\n  color: #47444f;\r\n  display: block;\r\n}\r\n\r\n.list-group-item-heading {\r\n  font-size: medium;\r\n  color: #171514;\r\n  display: block;\r\n}\r\n\r\n.small-text {\r\n  font-size: smaller;\r\n  display: block;\r\n}\r\n\r\n.list-group-item {\r\n  display: block;\r\n  border-radius: 0;\r\n}\r\n\r\n.list-group-item:hover {\r\n  cursor: pointer;\r\n  background-color: #eaeaea;\r\n}\r\n\r\n.light-txt {\r\n  color: #5c5c5c;\r\n}\r\n\r\n.btn {\r\n  width: 100%;\r\n}\r\n\r\n.activestaus {\r\n  color: #ffffff;\r\n  background-color: #efefef;\r\n}\r\n\r\n.task-alert {\r\n  margin: 0px;\r\n  padding: 5px;\r\n}\r\n\r\n.btn {\r\n  border-color: #6d6d6d;\r\n}\r\n\r\n.alert-light {\r\n  color: #969696;\r\n  padding-top: 25px;\r\n}\r\n\r\n.small-text {\r\n  font-size: smaller;\r\n}\r\n\r\n.big-text {\r\n  font-size: large;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/tasks-panel/tasks-panel.component.css
// module id = ../../../../../src/app/tasks-panel/tasks-panel.component.css
// module chunks = main